/* This example requires Tailwind CSS v2.0+ */
import React from 'react';
import styled from 'styled-components';
import { FaCheckCircle as Icon } from 'react-icons/fa';
import { GatsbyImage } from 'gatsby-plugin-image';

import {
  Section,
  Container,
  Switcher,
  SanityBlockContent,
  Grid,
  Col,
} from '../../common';
import { useResponsiveInViewConfigMargin } from '../../../hooks';

const StyledHeader = styled.div`
  h2 {
    color: ${(props) => props.$h2Color};
  }
`;

const StyledIcon = styled.div`
  color: ${(props) => props.$color};
`;

const Checklist = ({ page, sanity, section }) => {
  const { colors } = sanity;
  const { header, checklist, image } = section;
  const inViewConfigMargin = useResponsiveInViewConfigMargin();

  return (
    <Section
      idName="checklist"
      padding="lg"
      bgColor={colors?.neutral?.dark}
      h2Color={colors?.secondary?.default}
    >
      <Container
        padding="none"
        classes="max-w-md px-4 lg:px-0 text-center sm:max-w-3xl lg:max-w-7xl"
        inViewConfigMargin={inViewConfigMargin}
      >
        <Grid classes="lg:grid-cols-5 gap-12">
          <Col
            padding="0"
            isBgColor={true}
            bgColor={colors?.neutral?.default}
            classes="lg:col-span-2"
          >
            <GatsbyImage
              image={image?.asset?.gatsbyImageData}
              alt={image?.alt}
              className="h-full w-full rounded-xl object-cover shadow-2xl drop-shadow-lg"
            />
          </Col>
          <Col
            padding="2rem"
            isBgColor={true}
            bgColor={colors?.primary?.default}
            classes="lg:col-span-3 space-y-12 text-left"
          >
            <StyledHeader
              $h2Color={colors?.neutral?.darker}
              $spanColor={colors?.accent?.dark}
              className="space-y-4"
            >
              <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl">
                {header?.headline}
              </h2>
              <div className="max-w-prose text-2xl italic text-white">
                <SanityBlockContent
                  sanity={sanity}
                  page={page}
                  blocks={header?._rawDescription}
                />
              </div>
            </StyledHeader>
            <ul className="space-y-8 text-2xl font-semibold text-white lg:columns-2">
              {checklist?.items?.map((item) => (
                <li className="flex flex-row">
                  <StyledIcon
                    $color={colors?.accent?.default}
                    className="mr-3 mt-1"
                  >
                    <Icon />
                  </StyledIcon>
                  <SanityBlockContent
                    sanity={sanity}
                    page={page}
                    blocks={item?._rawDescription}
                  />
                </li>
              ))}
            </ul>
          </Col>
        </Grid>
      </Container>
    </Section>
  );
};

export { Checklist };
